import gql from "graphql-tag";
import UserSettings from "../fragments/UserSettings";

export default gql`
  query Selfie {
    selfie {
      _id
      firstName
      lastName
      fullName
      email
      isConnectedWithGoogle
      hasPasswordSet
      isPremium
      isSiteAdmin
      pictureUrl
      ...UserSettings
    }
  }

  ${UserSettings}
`;
